import { render, staticRenderFns } from "./FilterBarProviderSeoFriendly.vue?vue&type=template&id=1bb4e80a&scoped=true&"
import script from "./FilterBarProviderSeoFriendly.vue?vue&type=script&lang=ts&"
export * from "./FilterBarProviderSeoFriendly.vue?vue&type=script&lang=ts&"
import style0 from "./FilterBarProviderSeoFriendly.vue?vue&type=style&index=0&id=1bb4e80a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4e80a",
  null
  
)

export default component.exports